export default __webpack_public_path__ + "static/media/client-1.132a5620.jpg";